import { decode } from "html-entities"

export const URLS = {
  VIDEO_URLS: {
    QUESTIONNAIRE_OVERVIEW:
      "https://turnus-internal-files-database.s3.eu-central-1.amazonaws.com/Tutorial+Videos/turnus.ai_Fragebogen+U%CC%88bersicht_tutorial.mp4",
    DATA_TUTORIAL:
      "https://turnus-internal-files-database.s3.eu-central-1.amazonaws.com/Tutorial+Videos/turnus.ai_Database_tutorial.mp4",
    UPLOAD:
      "https://turnus-internal-files-database.s3.eu-central-1.amazonaws.com/Tutorial+Videos/turnus.ai_Fragebogen+upload_tutorial.mp4",
    SMART_KB:
      "https://turnus-internal-files-database.s3.eu-central-1.amazonaws.com/Tutorial+Videos/Database+tagging.mp4",
  },
  GIVE_FEEDBACK:
    "mailto:support@turnus.ai?subject=Free-Trial%20Feedback%20zu%20turnus.ai&body=Hallo%20liebes%20turnus.ai%20Team%2C%0AIch%20m%C3%B6chte%20euch%20hier%20ein%20kurzes%20Feedback%20zur%20Umgebung%20geben%3A%0A- Punkt 1%0A- Punkt 2%0A- Punkt 3%0ABesonders%20positiv%20ist%20mir%20aufgefallen%3A%0A- Punkt 1%0A- Punkt 2%0ADankesch%C3%B6n%20f%C3%BCr%20das%20kostenlose%20testen%2C%20ich%20werde%20weiter%20testen.%0ABeste%20Gr%C3%BC%C3%9Fe",
  ENTERPRISE_CONTACT: "mailto:support@turnus.ai?subject=turnus.ai%20Enterprise",
  SUPPORT: "https://turnus.ai/hilfecenter",
  INFO_BOX: {
    HELP_FAQ: "https://turnus.ai/hilfecenter",
    AGBS: "https://turnus.ai/footer-links/agbs",
    DATA_POLICY: "https://turnus.ai/footer-links/datenschutz",
    HELP: "mailto:support@turnus.ai",
    FEEDBACK:
      "https://outlook.office365.com/book/Demo@turnus.ai/s/OkW026zanUiVmUGu0p-grw2",
  },
} as const

export function normalizeSheetName(value: string | undefined | null): string {
  if (!value) {
    return ""
  }

  return decode(value)
}
